import { ChallengeService } from '@duck/api-definitions'
import { Button } from '@duck/ui'
import { Sparkles } from 'lucide-react'
import { useTar } from '@/modules'
import { ChallengeDetail } from '../ChallengeDetail'

/**
 * Celebratory finish for a single picked challenge. Reuses ChallengeDetail —
 * which already renders the cover, meta, description, proficiencies, and a
 * Start CTA wired to `onStart` — so no second Start button is added here.
 */
export const HelpMePickResult = ({
  challenge,
  onStart,
  onPickAnother,
  onBackToMatches,
}: {
  challenge: ChallengeService.AvailableChallenge
  onStart: () => void
  onPickAnother?: () => void
  onBackToMatches?: () => void
}) => {
  const { t } = useTar()
  return (
    <div className="flex h-full w-full max-w-md flex-col">
      <div className="mb-3 flex flex-none items-center justify-center gap-2 text-accent sm:mb-4">
        <Sparkles className="h-5 w-5" />
        <span className="text-sm font-semibold uppercase tracking-wider">{t('challenges.helpMePick.resultTitle')}</span>
      </div>
      <div className="min-h-0 flex-1 overflow-hidden rounded-3xl border border-border bg-background shadow-lg">
        <ChallengeDetail challenge={challenge} onStart={onStart} coverClassName="h-28 w-full flex-none sm:h-44" />
      </div>
      {(onPickAnother !== undefined || onBackToMatches !== undefined) && (
        <div className="mt-3 flex flex-none items-center justify-center gap-3 sm:mt-4">
          {onPickAnother !== undefined && (
            <Button variant="outline" size="sm" onClick={onPickAnother}>
              {t('challenges.helpMePick.pickAnother')}
            </Button>
          )}
          {onBackToMatches !== undefined && (
            <Button variant="ghost" size="sm" onClick={onBackToMatches}>
              {t('challenges.helpMePick.backToMatches')}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
